// extracted by mini-css-extract-plugin
export default {"container":"table-module__container__Pmuoq","secondLine":"table-module__secondLine__JcSve"};